<div class="w-full flex flex-col pt-5 gap-md">
  <div class="flex justify-between items-center">
    <div class="flex items-center gap-lg">
      <span class="text-4xl font-bold">
        {{ "MasterData.PlansGrid.Title" | i18nextEager }}
      </span>
      @if (divisions.value()?.data; as divs) {
        @if (divs.length > 1) {
          <doka-select class="w-48" [value]="effectiveDivisionId()" (valueChange)="onDivisionChange($any($event))">
            @for (division of divs; track division.id) {
              <doka-select-option [value]="division.id" [label]="division.name"></doka-select-option>
            }
          </doka-select>
        }
      }
    </div>
    <div>
      <doka-button (click)="createNewFiscalYear()" icon="add" [disabled]="divisions.isLoading() || !effectiveDivisionId()">
        <ng-template #text>
          {{ "MasterData.NewFiscalYearModal.ButtonTitle" | i18nextEager }}
        </ng-template>
      </doka-button>
    </div>
  </div>

  <doka-search-field (valueChange)="searchText.set($event)" [placeholder]="'Common.Search' | i18nextEager" />

  @if (fiscalYears.isLoading()) {
    <app-spinner />
  } @else if (filteredFiscalYears().length === 0) {
    <app-empty-state
      [message]="'EmptyState.NoFiscalYears'"
      [description]="'EmptyState.NoFiscalYearsDescription'"
      [icon]="'event_note'"
    />
  } @else {
    <doka-table>
      <doka-thead>
        <doka-tr>
          <doka-th>
            {{ "MasterData.PlansGrid.FiscalYear" | i18nextEager }}
          </doka-th>
          <doka-th>
            {{ "MasterData.PlansGrid.PlannedCountries" | i18nextEager }}
          </doka-th>
          <doka-th />
        </doka-tr>
      </doka-thead>
      <doka-tbody>
        @for (fiscalYear of filteredFiscalYears(); track fiscalYear.id) {
          <doka-tr>
            <doka-td>{{ fiscalYear.year }}</doka-td>
            <doka-td [title]="fiscalYear.plannedCountryNames.join(', ')">
              @let names = fiscalYear.plannedCountryNames;
              @for (name of names.slice(0, maxVisibleCountries); track name; let last = $last) {
                {{ name }}{{ !last ? ", " : names.length > maxVisibleCountries ? ", ..." : "" }}
              } @empty {
                -
              }
            </doka-td>
            <doka-td>
              @if (!fiscalYear.hasGlobalPlan) {
                <div class="flex justify-end">
                  <doka-button
                    (click)="applyFiscalYearToAllCountries(fiscalYear.id)"
                    icon="calendar_add_on"
                    [disabled]="divisions.isLoading() || !effectiveDivisionId()"
                    [buttonText]="'MasterData.PlansGrid.ApplyToAllCountries' | i18nextEager"
                  />
                </div>
              }
            </doka-td>
          </doka-tr>
        }
      </doka-tbody>
    </doka-table>
  }
</div>
